import React from 'react';
import ServicePageTemplate from '@/components/ServicePageTemplate';

const DiagnosticoPage: React.FC = () => {
  return <ServicePageTemplate serviceSlug="diagnostico" />;
};

export default DiagnosticoPage;